import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { StylesRouter } from '../../../utils/routes/MusicRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function StylesLayout() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/styles/',
      }}
    >
      <StylesRouter />
    </MainContentLayout>
  )
}
